import { createContext, ReactNode, useContext } from 'react';

import { ICFS } from '@/models';

interface UserCfsData {
  assigned: ICFS[];
  queued: ICFS[];
}

interface ProviderProps<T> {
  value?: T;
  children?: ReactNode | undefined;
  assignedUserCfs: ICFS[] | null;
  queuedUserCfs: ICFS[];
  fetchUserCfs: () => Promise<UserCfsData>;
}

const UserCfsContext = createContext<{
  assignedUserCfs: ICFS[] | null;
  queuedUserCfs: ICFS[];
  fetchUserCfs: () => Promise<UserCfsData>;
}>({
  assignedUserCfs: null,
  queuedUserCfs: [],
  fetchUserCfs: async () => ({ assigned: [], queued: [] }),
});

export const UserCfsProvider = ({
  assignedUserCfs,
  queuedUserCfs,
  fetchUserCfs,
  children,
}: ProviderProps<null>) => {
  return (
    <UserCfsContext.Provider
      value={{ assignedUserCfs, queuedUserCfs, fetchUserCfs }}
    >
      {children}
    </UserCfsContext.Provider>
  );
};

export const useUserCfs = () => useContext(UserCfsContext);
